module.exports = __webpack_public_path__ + "static/img/quiz_ulti_banner.70684f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/quiz_ulti_banner.png
// module id = hECK
// module chunks = 1